import { useEffect, useRef, useState } from "react";
import { ColumnsType } from "antd/es/table";
import {
  SearchFilterRef,
  SearchPayload,
} from "../../../core/common/ManagerSingleSearchFilter/types";
import { useNavigate } from "react-router";
import { PaginationType } from "../../../types/common-type";
import useApi from "../../../core/customhook/useApi";
import SearchFilter from "../../../core/common/ManagerSingleSearchFilter/SearchFilter";
import SnipperLoader from "../../../core/common/loader/SnipperLoader";
import Datatable from "../../../core/common/dataTable";
import TimelineModal from "../../../core/common/TimelineModal";
import { timelineData_invite } from "../../../core/data/js/dummy-data";
import { cellWidth } from "../../../core/methods/tableCellWidth";
import { safeLocaleCompare } from "../../../core/methods/sorterMethods";
import { formatDate } from "../../../core/common/TabelValue";
import ModifyInviteModal from "../../../core/common/ModifyInviteModal";

export const actionOptions = [
  { value: "stop_case", label: "Stop Case" },
  { value: "stop_check", label: "Stop Check" },
  { value: "add_check", label: "Add Check" },
  { value: "generate_report", label: "Generate Report" },
];

const initialSearchData: SearchPayload = {
  org_ids: [],
  project_ids: [],
  location_name: [],
  program_ids: [],
  department_ids: [],
};

const ExtraCost = ({ status_id }: { status_id: string }) => {
  const navigate = useNavigate();
  const [itemList, setItemList] = useState([]);
  const [showTimeline, setShowTimeline] = useState<boolean>(false);
  const filterRef = useRef<SearchFilterRef>(null);
  const [searchData, setSearchData] =
    useState<SearchPayload>(initialSearchData);

  const [showModifyInvite, setShowModifyInvite] = useState<boolean>(false);

  const [pagination, setPagination] = useState<PaginationType>({
    current: 1,
    pageSize: 1000, // limit of records
    total: 1,
  });

  const liveCaseProgress = useApi<any>(
    "/api/v1/agency/manager/hr-action-required",
    {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const handleSearch = async () => {
    try {
      const payload = {
        status: status_id,
        ...searchData,
        page: pagination?.current ?? 1,
        limit: pagination?.pageSize ?? 10,
      };
      const res = await liveCaseProgress.callApi(payload);

      if (!res?.success) {
        setItemList([]);
        return;
      }

      setItemList(res.data?.rows ?? []);
      setPagination((prev) => ({
        ...prev,
        total: res?.data?.pagination?.totalRecords || 0,
      }));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!status_id) return;
    handleSearch();
  }, [status_id, pagination?.current, pagination?.pageSize]);

  const handleClear = () => {
    filterRef.current?.clear();
  };

  const handleTableChange = (pgConfig: any) => {
    if (
      pgConfig.current !== pagination.current ||
      pgConfig.pageSize !== pagination.pageSize
    ) {
      setPagination((prev) => ({
        ...prev,
        current: pgConfig.current,
        pageSize: pgConfig.pageSize,
      }));
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: "S.No",
      key: "sno",
      align: "center",
      width: 80,
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Applicant Name",
      dataIndex: "applicant_name",
      key: "applicant_name",
      onCell: () => cellWidth(200),
      // render: (text) => (
      //   <div
      //     className="btn-link "
      //     onClick={() => {
      //       navigate(all_routes.manager_insufficiencyDetails);
      //     }}
      //   >
      //     {text}
      //   </div>
      // ),
      sorter: (a, b) => safeLocaleCompare(a, b, "applicant_name"),
    },
    {
      title: "Case Id",
      dataIndex: "case_id",
      key: "case_id",
      onCell: () => cellWidth(190),
      sorter: (a, b) => safeLocaleCompare(a, b, "case_id"),
    },
    {
      title: "Case Spoc",
      dataIndex: "case_spoc",
      key: "case_spoc",
      onCell: () => cellWidth(140),
      sorter: (a, b) => safeLocaleCompare(a, b, "case_spoc"),
    },
    {
      title: "Check Name",
      dataIndex: "check_name",
      key: "check_name",
      onCell: () => cellWidth(140),
      sorter: (a, b) => safeLocaleCompare(a, b, "check_name"),
    },
    {
      title: "Email ID",
      dataIndex: "email_id",
      key: "email_id",
      onCell: () => cellWidth(140),
      sorter: (a, b) => safeLocaleCompare(a, b, "email_id"),
    },
    {
      title: "Insufficiency Type",
      dataIndex: "insufficiency_type",
      key: "insufficiency_type",
      onCell: () => cellWidth(140),
      sorter: (a, b) => safeLocaleCompare(a, b, "insufficiency_type"),
    },
    {
      title: "Raise Date",
      dataIndex: "raise_date",
      key: "raise_date",
      onCell: () => cellWidth(140),
      render: (value: string) => formatDate(value),
    },
    {
      title: "Elapsed Days",
      dataIndex: "days_elapsed",
      key: "days_elapsed",
      onCell: () => cellWidth(140),
      sorter: (a, b) => safeLocaleCompare(a, b, "days_elapsed"),
    },
  ];

  return (
    <div className="px-2">
      {/* filters */}

      <div className="card shadow-sm border-0">
        <div className="card-body">
          <SearchFilter
            ref={filterRef}
            value={searchData}
            onChange={setSearchData}
            storageKey="liveCaseProgress"
          />

          {/* Buttons */}

          <div className="d-flex justify-content-end gap-2 mt-2">
            <button
              className="btn btn-primary px-4"
              onClick={handleSearch}
            // disabled={searchCaseAPI.loading}
            >
              <i className="ti ti-search me-1"></i>
              Search
              {/* {liveCaseProgress.loading ? "Searching..." : "Search"} */}
            </button>

            <button
              className="btn btn-outline-secondary px-4"
              onClick={handleClear}
            >
              <i className="ti ti-refresh me-1"></i>
              Clear Filter
            </button>
          </div>
        </div>
      </div>
      {/* Table  */}
      {liveCaseProgress.loading ? (
        <SnipperLoader />
      ) : (
        <div className="card mt-3">
          <Datatable
            dataSource={itemList}
            columns={columns}
            fixedHeader 
            tableHeight={650}
            Selection={false}
            pagination={pagination}
            handleTableChange={handleTableChange}
          />
        </div>
      )}

      {/* Timeline Modal */}
      {showTimeline && (
        <TimelineModal
          timelineData={timelineData_invite}
          onClose={() => setShowTimeline(false)}
        />
      )}

      {showModifyInvite && (
        <ModifyInviteModal
          handleClose={() => setShowModifyInvite(false)}
          handleSubmit={(d) => {
            console.log(d);
            setShowModifyInvite(false);
          }}
        />
      )}
    </div>
  );
};

export default ExtraCost;
